export default __webpack_public_path__ + "static/media/logo_title_white.ec5baea9.svg";